import RadioGroup from "../ui-components/RadioGroup";
import {FormattedMessage, useIntl} from "react-intl";
import React, {useState, useRef} from "react";
import Button from "../ui-components/Button";
import sharedApiRequest from "../services/apiRequest";
import {NotificationsContext} from "@ui-components/Notifications";
import {useContext} from "react";
import {ArrowUpTrayIcon} from "@heroicons/react/24/outline";
import moment from "moment";

const SuggestedUsersUploader = ({tableRef, importedFromOptions}) => {

  const {push} = useContext(NotificationsContext);
  const [importedFrom, setImportedFrom] = useState(null);
  const [uploadingUsers, setUploadingUsers] = useState(false);
  const hiddenCSVInputRef = useRef(null);
  const intl = useIntl();

  const csvToArrayOfObjects = (csv, sep = ';') => {
    const rows = csv.split('\n');
    const result = [];
    const headers = rows[0].split(sep).map(header => header.trim())
    for (const row of rows.slice(1)) {
      const obj = {};
      const values = row.split(sep);
      let valueIdx = 0;
      for (const value of values) {
        obj[headers[valueIdx]] = value.trim();
        valueIdx++;
      }
      result.push(obj);
    }
    return result;
  }

  const uploadSuggestedUsers = (users) => {
    setUploadingUsers(true)
    sharedApiRequest.post("/suggested_users/bulk_create", {users, source: importedFrom})
      .then((response) => {
        setUploadingUsers(false)
        tableRef.current && tableRef.current.onQueryChange()
        push({type: 'success', title: intl.formatMessage({id: 'users_uploaded'})})
      })
      .catch(() => {
        setUploadingUsers(false)
        push({type: 'error', title: intl.formatMessage({id: 'an_error_occurred'})})
      })
  }

  const sanitizeUsers = (users) => {
    console.log(users)
    console.log(moment)
    const valueOrNull = (value) => {
      if (!value || value === "")
        return null;
      return value;
    }
    const parseDate = (raw) => {
      if (!raw)
        return null;
      let date = moment(raw, 'DD/MM/YYYY', true); // works with sismica
      if (!date.isValid())
          date = moment(raw, 'YYYY-MM-DD', true); // works with geoforce one
      if (!date.isValid())
        return null;
      return date.format('YYYY-MM-DD')
    }
    console.log(parseDate)
    let sanitizedUsers = []
    let alreadyAddedEmail = []
    for (let user of users.filter((user) => user.Email !== "" && user.Email !== undefined)) {
      if (!(alreadyAddedEmail.includes(user.Email))) {
        sanitizedUsers.push({
          firstname: valueOrNull(user['Nome']),
          lastname: valueOrNull(user['Cognome']),
          email: user['Email'],
          phone: valueOrNull(user['Telefono']),
          mobile_phone: valueOrNull(user['Cellulare']),
          country: importedFrom !== "Sismica" ? valueOrNull(user['Stato']) : null,
          city: valueOrNull(user['Comune']),
          address: !!user['Via']
            ? user['Via'] + (!!user['Civico'] ? ` ${user['Civico']}` : "")
            : null,
          zip_code: valueOrNull(user['CAP']),
          qualification: valueOrNull(user['Professione']),
          license_expiration_date: parseDate(user['Scadenza Lic.']),
          subscription_date: parseDate(user['Data Iscrizione']),
        })
        alreadyAddedEmail.push(user.Email)
      }
    }
    return sanitizedUsers
  }

  if (!importedFromOptions?.length)
    return null;

  return <>
    <h3 className="font-semibold text-lg mb-4">
      <FormattedMessage id="import_file" defaultMessage="Importa file" />
    </h3>
    <div className="flex flex-col md:flex-row gap-4 items-center">
      <div className="md:mr-10 md:-mb-2">
        <RadioGroup
          id="source"
          title={intl.formatMessage({id: "imported_from"}) + ":"}
          description={""}
          options={importedFromOptions}
          currentValue={importedFrom}
          onChange={(value) => {
            setImportedFrom(value);
          }}
          horizontal
        />
      </div>
      <input
        type={"file"}
        ref={hiddenCSVInputRef}
        style={{display: "none"}}
        onChange={(e) => {
          const file = (e.target.files[0]);
          setUploadingUsers(true)
          const reader = new FileReader();
          reader.onload = function (evt) {
            if (evt.target.readyState !== 2) return;
            if (evt.target.error) {
              alert('Error while reading file');
              return;
            }
            let filecontent = evt.target.result;
            const users = csvToArrayOfObjects(filecontent, ';');
            const usersSanitized = sanitizeUsers(users)
            uploadSuggestedUsers(usersSanitized);
          }
          reader.readAsText(file)
        }}
      />
      <Button
        paddingCls="py-3 px-5"
        disabled={importedFrom === null}
        onClick={() => {
          hiddenCSVInputRef.current.value = null;
          hiddenCSVInputRef.current.click();
        }}
        submitting={uploadingUsers}
      >
        <ArrowUpTrayIcon className="w-4 mr-1" />
        {intl.formatMessage({id: "upload"})}
      </Button>
    </div>
  </>
}

export default SuggestedUsersUploader;